<form
    class="flex flex-col"
    [formGroup]="formGroup()">
    <mat-form-field>
        <mat-label>Conversion type</mat-label>
        <mat-select formControlName="conversionType">
            @for (item of ConversionType | appEnumKeyValue | appFilter: filterFn; track $index) {
                <mat-option [value]="item.value">{{ item.key }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    @if (formGroup().value.goalType != CampaignOfferGoalType.AdRevenueCashback) {
        <mat-form-field>
            <mat-label>Cash reward</mat-label>
            <input
                matInput
                type="number"
                noScroll
                formControlName="reward" />
        </mat-form-field>
        <p class="mb-1 text-base">Cash rewards by countries</p>
        <div
            class="mb-4 rounded-xl border border-gray-600 p-5"
            formArrayName="rewardsByCountries">
            <button
                class="mb-3"
                type="button"
                mat-flat-button
                color="primary"
                (click)="addCountryReward()">
                Add reward
            </button>
            @for (item of formGroup().controls.rewardsByCountries.controls; track item) {
                <div
                    class="flex gap-x-2"
                    [formGroupName]="$index">
                    <mat-form-field>
                        <mat-label>Country code</mat-label>
                        <input
                            matInput
                            formControlName="countryCode" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Reward</mat-label>
                        <input
                            matInput
                            type="number"
                            noScroll
                            formControlName="reward" />
                    </mat-form-field>

                    <button
                        (click)="removeCountryReward($index)"
                        type="button"
                        mat-icon-button>
                        <mat-icon class="text-red-500 !size-16 !text-5xl">delete</mat-icon>
                    </button>
                </div>
            }
        </div>
    }
    <mat-form-field>
        <mat-label>Exp reward</mat-label>
        <input
            matInput
            type="number"
            noScroll
            formControlName="expReward" />
    </mat-form-field>
    @if (formGroup().value.goalType == CampaignOfferGoalType.AdRevenueCashback) {
        <mat-form-field>
            <mat-label>Cashback reward rate</mat-label>
            <input
                matInput
                type="number"
                noScroll
                formControlName="cashbackRewardRate" />
        </mat-form-field>
    }
    <mat-form-field>
        <mat-label>Billing price</mat-label>
        <input
            matInput
            type="number"
            noScroll
            formControlName="billingPrice" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Affise goal</mat-label>
        <input
            matInput
            formControlName="affiseGoal" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Event name</mat-label>
        <input
            matInput
            formControlName="eventName" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Event template name</mat-label>
        <input
            matInput
            formControlName="eventTemplateName" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            formControlName="description"></textarea>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Order</mat-label>
        <input
            matInput
            type="number"
            noScroll
            formControlName="order" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Goal type</mat-label>
        <mat-select formControlName="goalType">
            @for (item of CampaignOfferGoalType | appEnumKeyValue; track $index) {
                <mat-option [value]="item.value">{{ item.key }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    @switch (formGroup().value.goalType) {
        @case (CampaignOfferGoalType.LevelUp) {
            <mat-form-field>
                <mat-label>Max events per day</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="maxEventsPerDay" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Max total events</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="maxTotalEvents" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Level up values</mat-label>
                <mat-chip-grid
                    #chipGrid
                    formControlName="levelUpValues">
                    @for (tag of formGroup().controls.levelUpValues.value; track tag) {
                        <mat-chip-row (removed)="removeLevelUpValue(tag)">
                            {{ tag }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input
                    [matChipInputFor]="chipGrid"
                    (matChipInputTokenEnd)="addLevelUpValue($event)" />
            </mat-form-field>
        }
        @case (CampaignOfferGoalType.LimitedOffer) {
            <mat-form-field>
                <mat-label>Iap value</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="iapValue" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Iap count</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="iapCount" />
            </mat-form-field>
        }
        @case (CampaignOfferGoalType.Event) {
            <mat-form-field>
                <mat-label>Iap value</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="iapValue" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Iap count</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="iapCount" />
            </mat-form-field>
        }
        @case (CampaignOfferGoalType.AccumulatedRevenue) {
            <mat-form-field>
                <mat-label>Iap value</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="iapValue" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Iap count</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="iapCount" />
            </mat-form-field>
        }
        @case (CampaignOfferGoalType.DailyLogin) {
            <mat-form-field>
                <mat-label>Daily login days</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="dailyLoginDays" />
            </mat-form-field>
        }
        @case (CampaignOfferGoalType.DailyLoginCounter) {
            <mat-form-field>
                <mat-label>Daily login days</mat-label>
                <input
                    matInput
                    type="number"
                    noScroll
                    formControlName="dailyLoginDays" />
            </mat-form-field>
        }
    }
    <div class="flex gap-x-4">
        <mat-form-field>
            <mat-label>Start date</mat-label>
            <input
                matInput
                [matDatepicker]="startDate"
                formControlName="startDate" />
            <mat-datepicker-toggle
                matIconPrefix
                [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>End date</mat-label>
            <input
                matInput
                [matDatepicker]="endDate"
                formControlName="endDate" />
            <mat-datepicker-toggle
                matIconPrefix
                [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Offset start date</mat-label>
            <input
                matInput
                type="number"
                noScroll
                formControlName="offsetStartDate" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Offset duration</mat-label>
            <input
                matInput
                formControlName="offsetDuration" />
            <mat-hint>d.hh:mm</mat-hint>
        </mat-form-field>
    </div>
    <mat-form-field class="mb-4">
        <mat-label>Min timeout after install</mat-label>
        <input
            matInput
            type="number"
            noScroll
            formControlName="antiFraudTimeout" />
        <mat-hint>in seconds</mat-hint>
    </mat-form-field>
    <mat-checkbox
        color="primary"
        formControlName="isActive">
        Active
    </mat-checkbox>
    <mat-checkbox
        color="primary"
        formControlName="isExtra">
        Extra
    </mat-checkbox>
</form>
